import {
  PropertyAdCategoryTypeEnum,
  PropertyAdStatusEnum,
  PropertyAdTypeEnum,
} from 'types/enums'

export const AD_CATEGORY_TYPE_OPTIONS = [
  {
    label: 'tables.propertyAds.adType.property',
    value: PropertyAdTypeEnum.PROPERTY,
  },
  {
    label: 'tables.propertyAds.adType.commercial',
    value: PropertyAdTypeEnum.COMMERCIAL,
  },
  { label: 'tables.propertyAds.adType.land', value: PropertyAdTypeEnum.LAND },
]

export const CATEGORY_TYPE_OPTIONS = [
  {
    label: 'tables.propertyAds.categoryType.sell',
    value: PropertyAdCategoryTypeEnum.Sell,
  },
  {
    label: 'tables.propertyAds.categoryType.rent',
    value: PropertyAdCategoryTypeEnum.Rent,
  },
]

export const PROPERTY_STATUS_OPTIONS = [
  {
    label: 'tables.propertyAds.status.active',
    value: PropertyAdStatusEnum.Active,
  },
  {
    label: 'tables.propertyAds.status.inactive',
    value: PropertyAdStatusEnum.Inactive,
  },
  {
    label: 'tables.propertyAds.status.invalid',
    value: PropertyAdStatusEnum.Invalid,
  },
]
